import { jsxs as r, jsx as l } from "react/jsx-runtime";
const v = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M52.509 49.358v-20.05h4.604l.86-3.003h-5.48L46.93 14.829H16.66l-5.105 11.476H6.02l.86 3.002h4.66v20.05h10.242v-5.754h20.485v5.755h10.242ZM37.475 17.832h7.389l4.107 8.473H33.474l4.001-8.473Zm-18.678 0h11.668l-4.002 8.473H15.028l3.77-8.473Zm-4.05 22.745V29.309h34.556v11.268H14.746Z"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M38.036 34.392H26.013v1.901h12.023v-1.901Z" })
    ]
  }
);
export {
  v as Car
};
